import React from 'react'
import CommonBanner from '../component/Common/CommonBanner'
import HotelBookingArea from 'component/HotelBooking'
import { useTranslation } from 'react-i18next';
const HotelBooking = () => {
  const { t } = useTranslation();
  return (
    <>
    <CommonBanner heading={t("bookingSubmission")} pagination="Booking submission"/>
    <HotelBookingArea/>
    </>
  )
}

export default HotelBooking